import BankCardsTable from "../../components/fin/BankCardsTable";

export default function Banks() {
  return <BankCardsTable />;
}
